
<div class="flow-dash-card" :state="state">
	<div class="flow-dash-card-title">
		<slot name="title" />
	</div>
	<div class="flow-dash-card-content">
		<slot />
	</div>
</div>
